/**
 * Organization API Service
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";

export interface OrganizationDetails {
  id: string;
  name: string;
  slug: string;
  keycloak_realm: string | null;
  description: string | null;
  website: string | null;
  contact_email: string | null;
  logo_url: string | null;
  is_active: boolean;
  geo_version: number;
}

export const organizationApi = {
  /**
   * Get current organization details
   */
  getOrganization: async (): Promise<OrganizationDetails> => {
    return api.get<OrganizationDetails>(ENDPOINTS.ORGANIZATION_CURRENT);
  },
};

export default organizationApi;
